// extracted by mini-css-extract-plugin
module.exports = {"partners":"partners_partners__ErXFq","light":"partners_light__g3AOu","logoList":"partners_logoList__8k4_c","spaceBetween":"partners_spaceBetween__OGnnC"};